import type { CSSProperties } from 'react';

export function Spinner({ inline = false }: { inline?: boolean }) {
  const size = inline ? 14 : 32;
  const style: CSSProperties = {
    width: size,
    height: size,
    borderRadius: '50%',
    border: `${inline ? 1.5 : 3}px solid var(--border)`,
    borderTopColor: 'var(--horizon-glow)',
  };
  if (inline) return <span className="spin" style={{ ...style, display: 'inline-block' }} />;
  return (
    <div style={{ display: 'grid', placeItems: 'center', padding: 'var(--sp-9) 0' }}>
      <div className="spin" style={style} />
    </div>
  );
}
